import React from "react";
import { useSelector } from "react-redux";
import { Table, Card } from "antd";
import { Link, useNavigate } from "react-router-dom";
import router from "../../assets/router.svg";
import battery from "../../assets/battery.svg";

import Echarts from "./Echarts";

const InsightsReturn = () => {
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.insight.tab1.isLoading);
  const assets = useSelector((state) => state.insight.tab1.data?.assets);
  const reporting = useSelector((state) => state.insight.tab1.data?.reporting);

  const columns = [
    {
      title: "",
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <span
          style={
            text === "TOTAL"
              ? { fontSize: "16px", fontWeight: "700", fontFamily: "VerizonNHGDSBold" }
              : { fontSize: "15px", fontWeight: "300" }
          }
        >
          {text}{" "}
        </span>
      ),
    },
    {
      title: <span className="amt-table-header">CANS</span>,
      dataIndex: "prod",
      key: "prod",
      render: (text, record) => (
        <span>
          {text[0] !== "Full" ? (
            <Link
              onClick={(e) => {
                e.preventDefault();
                navigate("/assets", {
                  state: {
                    assetType: "CAN",
                    location_Id: record?.key,
                    location: record?.name !=="TOTAL" ? record?.name : "",
                    org_Id: record?.orgId,
                    org_name: record?.orgName,
                    productiveStatus: "PRODUCTIVE",
                  },
                });
              }}
              style={{ color: "#00B845", textDecoration: "none" }}
              onMouseEnter={(e) =>
                (e.target.style.textDecoration = "underline")
              }
              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "300",
                  color: "#000000",
                }}
              >
                {text[0]}
              </span>
            </Link>
          ) : (
            <span
              style={{
                fontSize: "16px",
                fontWeight: "400",
                color: "#000000",
              }}
            >
              {text[0]}
            </span>
          )}
          /
          {text[1] !== "Empty" ? (
            <Link
              onClick={(e) => {
                e.preventDefault();
                navigate("/assets", {
                  state: {
                    assetType: "CAN",
                    location_Id: record?.key,
                    location: record?.name !=="TOTAL" ? record?.name : "",
                    org_Id: record?.orgId,
                    org_name: record?.orgName,
                    productiveStatus: "UNPRODUCTIVE",
                  },
                });
              }}
              style={{ color: "#000000", textDecoration: "none" }}
              onMouseEnter={(e) =>
                (e.target.style.textDecoration = "underline")
              }
              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
            >
              <span
                style={
                  text !== "Empty" && {
                    fontSize: "15px",
                    fontWeight: "300",
                    color: "#000000",
                  }
                }
              >
                {text[1]}
              </span>
            </Link>
          ) : (
            <span
              style={
                text !== "Empty" && {
                  fontSize: "16px",
                  fontWeight: "400",
                  color: "#000000",
                }
              }
            >
              {text[1]}
            </span>
          )}
        </span>
      ),
    },
    {
      title: <span className="amt-table-header">HOSES</span>,
      dataIndex: "idle",
      key: "idle",
      render: (text, record) => (
        <span>
          {text[0] !== "Clean" ? (
            <Link
              onClick={(e) => {
                e.preventDefault();
                navigate("/assets", {
                  state: {
                    assetType: "HOSE",
                    location_Id: record?.key,
                    location: record?.name !=="TOTAL" ? record?.name : "",
                    org_Id: record?.orgId,
                    org_name: record?.orgName,
                    productiveStatus: "PRODUCTIVE",
                  },
                });
              }}
              style={{ color: "#000000", textDecoration: "none" }}
              onMouseEnter={(e) =>
                (e.target.style.textDecoration = "underline")
              }
              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "300",
                  color: "#000000",
                }}
              >
                {text[0]}
              </span>
            </Link>
          ) : (
            <span
              style={{
                fontSize: "16px",
                fontWeight: "400",
                color: "#000000",
              }}
            >
              {text[0]}
            </span>
          )}
          /
          {text[1] !== "Used" ? (
            <Link
              onClick={(e) => {
                e.preventDefault();
                navigate("/assets", {
                  state: {
                    assetType: "HOSE",
                    location_Id: record?.key,
                    location: record?.name !=="TOTAL" ? record?.name : "",
                    org_Id: record?.orgId,
                    org_name: record?.orgName,
                    productiveStatus: "UNPRODUCTIVE",
                  },
                });
              }}
              style={{ color: "#000000", textDecoration: "none" }}
              onMouseEnter={(e) =>
                (e.target.style.textDecoration = "underline")
              }
              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "300",
                  color: "#000000",
                }}
              >
                {text[1]}
              </span>
            </Link>
          ) : (
            <span
              style={{
                fontSize: "16px",
                fontWeight: "400",
                color: "#000000",
              }}
            >
              {text[1]}
            </span>
          )}
        </span>
      ),
    },
  ];

  return (
    <div
      style={{
        minHeight: "65vh",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Table
        title={() => <h5 className="amt-table-headline">Asset Counts</h5>}
        columns={columns}
        loading={isLoading}
        dataSource={assets}
        pagination={{
          pageSize: 50,
          total: assets.length,
          hideOnSinglePage: true,
        }}
        rowClassName="newRow"
      />
      <div className="reporting-gateway-container">
        <div className="reporting-gateway-heading">Reporting Gateways</div>
        <div className="reporting-gateway-data-row">
          <div className="reporting-gateway-data-col">
            <div className="reporting-gateway-title">GATEWAY COUNT</div>
            <div className="reporting-gateway-count">
              <h5 className="gateway-count">{reporting.gatewayCount}</h5>
              <img
                src={router}
                width="24px"
                height="24px"
                alt="gateway-count"
              />
              <span
                className={reporting.percentageonline >= 75 ? "up" : "down"}
              >
                7 days
              </span>
            </div>
          </div>
          <div className="reporting-gateway-data-col">
            <div className="reporting-gateway-title">AVG BATTERY</div>
            <div className="reporting-gateway-count">
              <h5 className="avg-battery">{reporting.avgBattery}%</h5>
              <img src={battery} width="24px" height="24px" alt="avg-battery" />
              <span className={reporting.avgBattery >= 75 ? "up" : "down"}>
                7 days
              </span>
            </div>
          </div>
        </div>
      </div>

      <Card style={{
        borderRadius: "12px"
      }}>
        <Echarts />
      </Card>
    </div>
  );
};

export default InsightsReturn;
